<template>
  <v-dialog
    v-model="model"
    :width="width"
    scrollable
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card>
      <!-- HEADER -->
      <v-card-title class="cyan darken-1 white--text">
        <span class="text-subtitle-2">{{ title }}</span>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <!-- CONTENT -->
      <v-card-text class="pa-2">
        <slot />
      </v-card-text>

      <v-divider />

      <!-- ACTION -->
      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    title: String,
    width: {
      type: [String, Number],
      default: 800
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    }
  },

  methods: {
    close() {
      this.model = false
    }
  }
}
</script>